/* LAYOUT */
export const CHANGE_LAYOUT = "CHANGE_LAYOUT"
export const CHANGE_LAYOUT_WIDTH = "CHANGE_LAYOUT_WIDTH"
export const CHANGE_SIDEBAR_THEME = "CHANGE_SIDEBAR_THEME"
export const CHANGE_SIDEBAR_TYPE = "CHANGE_SIDEBAR_TYPE"
export const IS_LOADING = "IS_LOADING"
export const MENU_ACTIVED = "MENU_ACTIVED"

// topbar
export const CHANGE_TOPBAR_THEME = "CHANGE_TOPBAR_THEME"

// topbar inside page
export const SHOW_TOPBAR_INSIDE = "SHOW_TOPBAR_INSIDE"

// show sidebar
export const SHOW_SIDEBAR = "SHOW_SIDEBAR"
export const TOGGLE_LEFTMENU = "TOGGLE_LEFTMENU"

/* RIGHT SIDEBAR */
export const SHOW_RIGHT_SIDEBAR = "SHOW_RIGHT_SIDEBAR"

/* TRANSACTIONS */
export const IS_TRANSACTION_NOT_FOUND = "IS_TRANSACTION_NOT_FOUND"
export const IS_TRANSACTION_WITH_ERROR = "IS_TRANSACTION_WITH_ERROR"

export const IS_MODAL_PAGE = "IS_MODAL_PAGE"
export const IS_IFRAME_PAGE = "IS_IFRAME_PAGE"
